module.exports = __webpack_public_path__ + "img/jiayou.7894acbb.png";